/**
 * Regole pure del controllo doppioni di lead/clienti (nessun accesso al DB).
 * Email senza distinzione di maiuscole, telefono senza spazi/simboli e con o
 * senza prefisso +39, P.IVA e codice fiscale normalizzati.
 */

export interface DuplicateCriteria {
  email?: string | null;
  phone?: string | null;
  vat_number?: string | null;
  tax_code?: string | null;
}

export const normEmail = (v?: string | null) => (v || '').trim().toLowerCase();
export const normPhone = (v?: string | null) => (v || '').replace(/[^\d+]/g, '');
export const normFiscal = (v?: string | null) => (v || '').replace(/\s+/g, '').toUpperCase();

/** Email valida abbastanza da cercarla (evita ricerche a meta' digitazione). */
export function searchableEmail(v?: string | null): string | null {
  const e = normEmail(v);
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e) ? e : null;
}

/** Forme con cui lo stesso numero puo' essere salvato (con/senza +39, con spazi originali). */
export function phoneVariants(raw?: string | null): string[] {
  const clean = normPhone(raw);
  if (clean.replace(/\D/g, '').length < 6) return [];
  const out = new Set<string>([clean, (raw || '').trim()]);
  if (clean.startsWith('+39')) out.add(clean.slice(3));
  else if (clean.startsWith('0039')) { out.add(clean.slice(4)); out.add(`+39${clean.slice(4)}`); }
  else if (!clean.startsWith('+')) out.add(`+39${clean}`);
  return Array.from(out).filter(Boolean);
}

/** Senza prefisso internazionale italiano, per confrontare due numeri. */
const phoneKey = (v?: string | null) => normPhone(v).replace(/^(\+39|0039)/, '');

/** Pattern ILIKE che corrisponde esattamente al testo (escape di \ % _). */
export function exactLikePattern(v: string): string {
  return v.replace(/[\\%_]/g, (c) => `\\${c}`);
}

/** Motivi per cui una scheda corrisponde ai criteri, nell'ordine Email, Telefono, P.IVA, CF. */
export function matchReasons(
  row: { email?: string | null; phone?: string | null; vat_number?: string | null; tax_code?: string | null },
  criteria: DuplicateCriteria,
): string[] {
  const out: string[] = [];
  const email = searchableEmail(criteria.email);
  if (email && normEmail(row.email) === email) out.push('Email');
  if (phoneVariants(criteria.phone).length && row.phone && phoneKey(row.phone) === phoneKey(criteria.phone)) out.push('Telefono');
  const vat = normFiscal(criteria.vat_number);
  if (vat && normFiscal(row.vat_number) === vat) out.push('Partita IVA');
  const cf = normFiscal(criteria.tax_code);
  if (cf && normFiscal(row.tax_code) === cf) out.push('Codice Fiscale');
  return out;
}
